import { usePage } from "PFApp/use_page";
import { ApiRoute } from "PFCore/utilities/routes";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const useCvTemplateEditPage = (initPage, { id, accountId }) => {
  const { t } = useTranslation("saasAdmin");
  const isNew = !id;
  const pageId = isNew ? "cv_templates/new" : `cv_templates/edit/${id}`;
  const { page, setPage, mergePage, resetPage } = usePage(pageId, initPage);
  const { cvTemplate, customTypes } = page;

  const fetchCustomTypes = () => {
    $.ajax({
      url: ApiRoute(`/api/custom_types`),
      data: {
        account_id: accountId,
        per_page: 1000
      },
      api_version: 2
    })
      .then((response) =>
        mergePage({
          customTypes: {
            loaded: true,
            data: response.entries
          }
        })
      )
      .catch(() => {
        mergePage({
          loaded: true,
          errors: [t("cvTemplates.edit.error")]
        });
      });
  };

  const fetch = () => {
    if (isNew) {
      mergePage({
        cvTemplate: {
          loaded: true,
          data: {}
        }
      });
    } else {
      $.ajax({
        url: ApiRoute(`/api/cv_templates/${id}`),
        api_version: 2,
        data: {
          account_id: accountId
        }
      })
        .then((response) =>
          mergePage({
            cvTemplate: {
              loaded: true,
              data: response
            }
          })
        )
        .catch(() =>
          mergePage({
            loaded: true,
            errors: [t("cvTemplates.edit.error")]
          })
        );
    }
  };

  useEffect(() => {
    setPage(initPage);
    return resetPage;
  }, []);

  useEffect(() => {
    fetch();
    fetchCustomTypes();
  }, []);

  useEffect(() => {
    if (customTypes.loaded && cvTemplate.loaded) {
      mergePage({
        loaded: true
      });
    }
  }, [customTypes, cvTemplate]);

  return { ...page, fetch };
};
